import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs, contactInfo } from "@/mocks/home";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="w-full bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="FAQ"
          title="자주 묻는"
          highlight="질문"
          desc="수리 전에 가장 많이 궁금해하시는 내용을 모았습니다. 더 궁금한 점은 언제든 문의해 주세요."
        />

        <div className="mx-auto mt-14 grid max-w-5xl grid-cols-1 gap-8 lg:grid-cols-[1.5fr_1fr]">
          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => {
              const open = openId === faq.id;
              return (
                <div
                  key={faq.id}
                  className={`reveal overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                    open ? "border-primary-300" : "border-background-200"
                  }`}
                  style={{ transitionDelay: `${index * 40}ms` }}
                >
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : faq.id)}
                    aria-expanded={open}
                    className="flex w-full items-center gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100/70"
                  >
                    <span className="font-heading text-base font-black text-primary-500">Q</span>
                    <span className="flex-1 font-heading text-[15px] font-bold text-foreground-950 md:text-base">
                      {faq.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all duration-300 ${
                        open ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className="ri-add-line text-lg"></i>
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-in-out ${
                      open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="border-t border-background-200 px-5 py-5 pl-[52px] font-body text-sm leading-relaxed text-foreground-600">
                        {faq.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <aside className="reveal h-fit rounded-lg border border-background-200 bg-background-100 p-6 lg:sticky lg:top-28">
            <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-question-answer-line text-2xl"></i>
            </span>
            <h3 className="mt-5 font-heading text-xl font-black text-foreground-950">
              찾으시는 답이 없나요?
            </h3>
            <p className="mt-2.5 font-body text-sm leading-relaxed text-foreground-600">
              전화 또는 온라인 문의로 증상을 알려주시면 담당 엔지니어가 직접 상담해 드립니다.
            </p>
            <div className="mt-6 flex flex-col gap-2.5">
              <a
                href={contactInfo.phoneHref}
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3.5 font-label text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-phone-fill text-base"></i>
                {contactInfo.phone}
              </a>
              <a
                href="#inquiry"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-3.5 font-label text-sm font-bold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-mail-send-line text-base"></i>
                온라인 문의하기
              </a>
            </div>
            <div className="mt-6 flex items-start gap-2.5 border-t border-background-200 pt-5">
              <i className="ri-time-line mt-0.5 text-primary-500"></i>
              <p className="font-body text-xs leading-relaxed text-foreground-600">
                {contactInfo.hours}
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}